import React from 'react'
import { shape, arrayOf, string } from 'prop-types'
import * as Styled from 'components/molecules/Offers/Offers.styles'
import { FeatureList } from 'components/molecules'

export const ReligiousOffers = ({ data }) => (
  <Styled.Offers>
    {data?.items && data.items.length > 0 && (
      <FeatureList
        itemList={ [{ title: '', items: data?.items }] }
        listClass={ 'list-checkmark' }
      />
    )}
    {!!data?.description && data.description !== '' && (
      <div className='additional'>
        <p
          dangerouslySetInnerHTML={{
            __html: data.description,
          }}></p>
      </div>
    )}
    {!!data?.additionalInfo && data.additionalInfo !== '' && (
      <div className='additional'>
        <p>{data.additionalInfo}</p>
      </div>
    )}
  </Styled.Offers>
)

ReligiousOffers.propTypes = {
  data: shape({
    items: arrayOf(string),
    description: string,
    additionalInfo: string,
  }),
}

export default ReligiousOffers
